var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12 m-t-10" }, [
        _c("div", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "BULK_BLOCKED_TAB_DESCRIPTION",
              expression: "'BULK_BLOCKED_TAB_DESCRIPTION'"
            }
          ],
          staticClass: "bs-callout bs-callout-sm bs-callout-primary description"
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-sm-offset-6 m-t-10 m-b-15 text-right" },
        [_c("SearchBulkBlockedNumber")],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12", attrs: { id: "app" } },
        [
          _c("BulkBlockNumbersForm", {
            attrs: {
              campaigns: _vm.campaigns,
              "action-status": _vm.actionStatus
            },
            on: { "bulk-block": _vm.onBulkBlock }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }